module.exports = __webpack_public_path__ + "media/handshake-message/handshake-message2-b9ee2260.png";